import { apiClient } from '../client'

class MediaRepository {
  /** Mint a fresh GCS signed read URL for a private object path. */
  async getSignedUrl(kind: 'static' | 'dynamic', path: string, tenantId?: number) {
    return apiClient.post<{
      url: string
      expires_in: number
      kind: string
      path: string
      tenant_id: number
    }>(
      '/media/signed-url',
      {
        kind,
        path,
        ...(tenantId ? { tenant_id: tenantId } : {}),
      },
      true,
      { silent: true, showSuccessToast: false, showErrorToast: false },
    )
  }

  /** Fresh signed URL for a SKU picture filename in sku_pictures/. */
  async signSkuPicture(photoName: string) {
    const name = String(photoName || '')
      .trim()
      .replace(/^\/+/, '')
    if (!name) return null
    const path = name.startsWith('sku_pictures/') ? name : `sku_pictures/${name}`
    const res = await this.getSignedUrl('static', path)
    return res?.url ? String(res.url) : null
  }

  /**
   * Fetch private object bytes via same-origin API proxy (auth via apiClient).
   * Used by frontend PDF builder only — does not generate PDFs on the server.
   */
  async fetchObjectBlob(kind: 'static' | 'dynamic', objectPath: string): Promise<Blob> {
    const path = String(objectPath || '')
      .trim()
      .replace(/^\/+/, '')
    if (!path) throw new Error('object path required')
    const qs = new URLSearchParams({ kind, path })
    return apiClient.getBlob(`/media/blob?${qs.toString()}`, true, {
      silent: true,
      showSuccessToast: false,
      showErrorToast: false,
    })
  }

  async fetchSkuPictureBlob(photoName: string): Promise<Blob | null> {
    const name = String(photoName || '')
      .trim()
      .replace(/^\/+/, '')
    if (!name) return null
    const path = name.startsWith('sku_pictures/') ? name : `sku_pictures/${name}`
    return this.fetchObjectBlob('static', path)
  }
}

export const mediaRepository = new MediaRepository()
